export default [
  {
    path: 'science-id',
    name: 'scienceid',
    component: () => import('@/views/pages/OneID.vue'),
    meta: {
      pageTitle: 'Science ID',
      layout: 'full',
      redirectIfLoggedIn: true,
      breadcrumb: [
        {
          text: 'Science ID',
          active: true,
        },
      ],
      resource: 'Auth',
    },
  },
  {
    path: 'one-id',
    redirect: { name: 'scienceid' },
  },
]
